import { render, staticRenderFns } from "./PackageDetails.vue?vue&type=template&id=7e03d253"
import script from "./PackageDetails.vue?vue&type=script&lang=js"
export * from "./PackageDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports